import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "product-card__addons",
  "data-eq-part": "product-card__addons"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "addon-section" }, " Zusatzoptionen ", -1)
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "addon-price" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "addon-section" }, "Hausanschluss", -1)
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]

import AppDate from '@/classes/AppDate';
import Product from '@/classes/Product';
import { env, formatNumber } from '@/helpers';
import TelevisionPackageInterface from '@/interfaces/TelevisionPackageInterface';
import { computed } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCardAddons',
  props: {
    product: {},
    cartItemKey: {}
  },
  setup(__props: any) {

const props = __props;

const getMonthlyBasePrice = (item: TelevisionPackageInterface) => item?.price?.recurring?.find((recurringPrice) => recurringPrice?.type === 'base_price')?.value || 0;
const getMonthlyBasePriceFormatted = (item: TelevisionPackageInterface) => formatNumber(getMonthlyBasePrice(item), 2);
const getOneTimeBasePrice = (item: TelevisionPackageInterface) => item?.price?.oneTime?.find((oneTimePrice) => oneTimePrice?.type === 'base_price')?.value || 0;
const getOneTimeBasePriceFormatted = (item: TelevisionPackageInterface) => formatNumber(getOneTimeBasePrice(item), 2);
const hasMonthly = (item: TelevisionPackageInterface) => getMonthlyBasePrice(item) > 0;
const hasPrice = (item: TelevisionPackageInterface) => (hasMonthly(item) ? getMonthlyBasePrice(item) : getOneTimeBasePrice(item)) > 0;

const addonsWithPrice = computed(() => props.product.addons.filter((addon) => hasPrice(addon.item)));

const store = useStore();
const blackWeekFrom = new AppDate('2023-11-27 00:00:00');
const blackWeekTill = new AppDate('2023-12-03 23:59:59');
window.AppDate = AppDate;
const currentDate = new AppDate();

const isBlackWeek = env('STAGING', false) || currentDate.isInRangeOff(blackWeekFrom, blackWeekTill);

const isBusiness = computed(() => store.getters['order/formData'].address.customerType === 'business');

const additionalPropertyConnectionOptions = computed(() => [
  { price: `${isBlackWeek ? '0,00' : '690,00'}&thinsp;€`, label: 'Hausanschluss inkl. 20 Meter', value: '20m' },
  { price: `${isBlackWeek ? '0,00' : '890,00'}&thinsp;€`, label: 'Hausanschluss inkl. 20-50 Meter', value: '20m-50m' },
  { price: isBusiness.value ? 'Individuelles Angebot' : `${isBlackWeek ? '310,00' : '1.200,00'}&thinsp;€`, label: 'Hausanschluss inkl. 50-80 Meter', value: '50m-80m' },
  { price: 'Individuelles Angebot', label: 'Hausanschluss mit über 80 Meter', value: 'individual' },
]);
const additionalPropertyConnection = computed<{price: string, label: string} | undefined>(() => {
  if (!props.cartItemKey) return undefined;
  const additionalConnection = store.getters['order/formData'].connection[props.cartItemKey]?.additionalPropertyConnection;
  if (!additionalConnection) return undefined;

  return additionalPropertyConnectionOptions.value.find((option) => option.value === additionalConnection);
});

const getAddonLabel = (addon: { category: string, item: TelevisionPackageInterface}) => {
  switch (addon.category) {
    case 'router':
      return `Router Upgrade: ${addon.item.name}`;
    case 'ipNetwork':
      return `IP-Netz: ${addon.item.name}`;
    case 'television-package':
      return `TV-${addon.item.name}`;
    case 'television-option':
      return `TV-Zusatzoption: ${addon.item.name}`;
    case 'television-addon':
      return `TV-Sprachpaket: ${addon.item.name}`;
    default:
      return addon.item.name;
  }
};

return (_ctx: any,_cache: any) => {
  return (addonsWithPrice.value.length || !!additionalPropertyConnection.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (addonsWithPrice.value.length)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_2,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addonsWithPrice.value, (addon, inx) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: `addon-${inx}`
                }, [
                  _createElementVNode("div", {
                    class: "addon-label",
                    innerHTML: getAddonLabel(addon)
                  }, null, 8, _hoisted_3),
                  _createElementVNode("div", _hoisted_4, [
                    (hasMonthly(addon.item))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(getMonthlyBasePriceFormatted(addon.item)) + " €/Monat ", 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (!hasMonthly(addon.item))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(getOneTimeBasePriceFormatted(addon.item)) + " € ", 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                ], 64))
              }), 128))
            ], 64))
          : _createCommentVNode("", true),
        (additionalPropertyConnection.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_5,
              _createElementVNode("div", {
                class: "addon-label",
                innerHTML: additionalPropertyConnection.value.label
              }, null, 8, _hoisted_6),
              _createElementVNode("div", {
                class: "addon-price",
                innerHTML: additionalPropertyConnection.value.price
              }, null, 8, _hoisted_7)
            ], 64))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})